module.exports = __webpack_public_path__ + "static/media/ico_circle_arrow_right.d26b240f.svg";